import React, { useContext, useState } from 'react'

import { AstuteContext } from '../../context'
import { AssetCard } from './AssetCard'
import { Text } from '@UILibrary/Text'
import { Button } from '@UILibrary/Button'
import { filterImportableAssets } from './helpers'
import { Grid } from '@UILibrary/Grid'
import { Pill } from '@UILibrary/Pill'

export const Content = ({
  returnedHoldings,
  pendingHoldings,
  erroredHoldings,
  totalHoldingsCount,
}) => {
  const {
    state: { astuteRequest, selectedAssets, assetTypeMapping },
    actions: {
      toggleAssetSelected,
      selectAssets,
      deselectAll,
      submitImportableAssets,
    },
  } = useContext(AstuteContext)

  const atLeastOneSelected = selectedAssets.length > 0

  const [importableAssets] = filterImportableAssets(
    returnedHoldings, assetTypeMapping, astuteRequest.last_refreshed_at
  )

  const [submittingAssets, setSubmittingAssets] = useState(false)

  const emptyImportableAssets = importableAssets.length === 0
  return (
    <>
      <Grid margin={{bottom: 'xl'}}>
        <Pill color="info" size="medium" iconBefore="info">
          Wealthbit relies on data provided by Astute and cannot guarantee it is complete or error-free.
        </Pill>
      </Grid>

      {emptyImportableAssets && (
        <p style={{ maxInlineSize: "55ch", marginBlockStart: "1rem", textAlign: "center" }}>Unfortunately no importable assets were found in this report.</p>
      )}
      {importableAssets.length ? (
        <>
          <Grid cols="a-1" margin={{bottom: 'xl'}}>
            <Text as='h4' textAlign='left' body><strong>WEALTHBIT COMPATIBLE PRODUCTS</strong></Text>
            <Text as='p' textAlign='right' body>{importableAssets.length} of {totalHoldingsCount}</Text>
          </Grid>

          <Grid cols='2' gap='l' padding={{horizontal: 'l'}} margin={{bottom: 'xl'}}>
            {importableAssets.map((rh, index) => (
              <AssetCard
                selectable={true}
                handleSelect={() => toggleAssetSelected(rh.index)}
                highlighted={selectedAssets.find((sa) => sa.index === rh.index)}
                key={index}
                holding={rh}
                margin='none'
              />
            ))}
          </Grid>

          <Grid cols='a-a' justifyContent='center' gap='l' margin={{bottom: 'm'}}>
            <Button
              size='small'
              textOnlyVariant='primary'
              onClick={() => deselectAll()}
              textOnly
            >
              <Text variety3>SELECT NONE</Text>
            </Button>

            <Button
              size='small'
              textOnlyVariant='primary'
              onClick={() => selectAssets(importableAssets) }
              textOnly
            >
              <Text variety3>SELECT ALL</Text>
            </Button>
          </Grid>

          <Grid cola='1' justifyContent='center' margin={{bottom: 'xxl'}}>
            <Button
              primary
              disabled={!atLeastOneSelected || submittingAssets}
              onClick={() => submitImportableAssets()}
              size='medium'
            >
              Add to client's current plan
            </Button>
          </Grid>
        </>
      ) : null}

      {pendingHoldings.length ? (
        <>
          <Grid cols="a-1" margin={{ bottom: 'xl' }}>
            <Text as='h4' textAlign='left' body><strong>ASTUTE ARE WAITING FOR THE FOLLOWING PROVIDERS</strong></Text>
            <Text as='p' textAlign='right' body>{pendingHoldings.length} of {totalHoldingsCount}</Text>
          </Grid>

          <Grid cols='2' gap='l' padding={{ horizontal: 'l' }} margin={{ bottom: 'xxl' }}>
            {pendingHoldings.map((ph, index) => (
              <AssetCard key={index} holding={ph} />
            ))}
          </Grid>
        </>
      ) : null}

      {erroredHoldings.length ? (
        <>
          <Grid cols="a-1" margin={{ bottom: 'xl' }}>
            <Text as='h4' textAlign='left' body><strong>ASTUTE FOUND NO DATA FOR THE FOLLOWING PROVIDERS</strong></Text>
            <Text as='p' textAlign='right' body>{erroredHoldings.length} of {totalHoldingsCount}</Text>
          </Grid>

          <Grid cols='2' gap='l' padding={{ horizontal: 'l' }} margin={{ bottom: 'xxl' }}>
            {erroredHoldings.map((eh, index) => (
              <AssetCard key={index} holding={eh} />
            ))}
          </Grid>
        </>
      ) : null}
    </>
  )
}
